/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { UnitDependencies } from './dependenciesUnitClass.generated.js';
import { createProtonMass } from '../../factoriesAny.js';
export var protonMassDependencies = {
  BigNumberDependencies,
  UnitDependencies,
  createProtonMass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesProtonMass.generated.js
// module id = qJdR
// module chunks = 3